import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';

@Component({
  selector: 'app-search-box-pop',
  templateUrl: './search-box-pop.component.html',
  styleUrls: ['./search-box-pop.component.scss']
})
export class SearchBoxPopComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<SearchBoxPopComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {}

  searchSlug = '';
  claimNumber = '';
  selectedDate = moment();
  locationText: any;

  ngOnInit(): void {
    if (this.data) {
      this.searchSlug = this.data['service'];
      this.claimNumber = this.data['params']?.['claim_number'] || '';
      this.selectedDate = moment(this.data['date']);
      this.locationText = this.data['location'];
    }
  }

  closeModal() {
    this.dialogRef.close();
  }
}
